import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _ from 'lodash';
import { store } from '../index.js';
import { getLabelClassByName, labelClass as defaultLabelClass } from '../redux/reducers/labelClasses';
import classifier from '../redux/reducers/classifier.js';
export var addExample = function addExample(binary, label) {
  var _store$getState = store.getState(),
      featureExtractor = _store$getState.featureExtractor,
      classifier = _store$getState.classifier;

  preProcessImageWithCallback(binary, function (img) {
    var features = featureExtractor.infer(img, 'conv_preds');
    classifier.addExample(features, label);
  });
};
export var reloadExamples = function reloadExamples(labelClass) {
  var _store$getState2 = store.getState(),
      classifier = _store$getState2.classifier,
      labelClasses = _store$getState2.labelClasses;

  var labels = Object.keys(classifier.classDatasetMatrices);
  var label = labels[labelClass.id - 1];

  var updatedLabelClass = _.find(labelClasses.list, {
    id: labelClass.id
  });

  try {
    classifier.clearClass(label);
  } catch (e) {
    console.log("error", e);
  }

  updatedLabelClass.images.forEach(function (img) {
    return addExample(img, labelClass.name);
  });
};
export var reloadAllExamples = function reloadAllExamples() {
  var _store$getState3 = store.getState(),
      classifier = _store$getState3.classifier,
      labelClasses = _store$getState3.labelClasses;

  var labels = Object.keys(classifier.classDatasetMatrices);
  labelClasses.list.forEach(function (label) {
    var labelObject = labels[label.id - 1];
    classifier.clearClass(labelObject);
    label.images.forEach(function (img) {
      return addExample(img, label.name);
    });
  });
};
export var deleteExamples = function deleteExamples(label) {
  var _store$getState4 = store.getState(),
      classifier = _store$getState4.classifier;

  try {
    classifier.clearClass(label);
  } catch (e) {}
};
export var predict = function predict(binary, uid) {
  return new Promise(function (resolve, reject) {
    var _store$getState5 = store.getState(),
        featureExtractor = _store$getState5.featureExtractor,
        classifier = _store$getState5.classifier,
        labelClasses = _store$getState5.labelClasses;

    preProcessImageWithCallback(binary, function (img) {
      var features = featureExtractor.infer(img, 'conv_preds');
      classifier.predictClass(features).then(function (result) {
        var labelClass = getLabelClassByName(labelClasses.list, result.label);
        var confidences = result.confidences;

        if (labelClass) {
          resolve(_objectSpread(_objectSpread({}, labelClass), {}, {
            uid: uid,
            confidences: confidences
          }));
        } else {
          reject('rebuilding model');
        }
      }).catch(function (_) {
        resolve(_objectSpread(_objectSpread({}, defaultLabelClass), {}, {
          uid: uid,
          rgb: {
            a: 0,
            r: 0,
            g: 0,
            b: 0
          }
        }));
      });
    });
  });
};

var preProcessImageWithCallback = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binary, callback) {
    var img;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            img = new Image(800, 600);
            img.src = "data:image/png;base64, ".concat(binary);

            img.onload = function () {
              callback(img);
            };

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function preProcessImageWithCallback(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();